<div class="headline">
  <h1 class="headline__title">{{ title }}</h1>
  <ng-container [ngTemplateOutlet]="contentTemplate"></ng-container>
</div>
